import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";

import { initializeApp } from "firebase/app";

Vue.config.productionTip = false;

const firebaseConfig = {
  apiKey: "AIzaSyAdzY-rjPIy5tkALlLmK675qyG_rAlJXv4",
  authDomain: "ascexpertlist.firebaseapp.com",
  projectId: "ascexpertlist",
  storageBucket: "ascexpertlist.appspot.com",
  messagingSenderId: "654636154394",
  appId: "1:654636154394:web:9d91539b3015be72571ba3",
  measurementId: "G-ZEH3KDT0WY",
};
// Initialize Firebase
const firebase = initializeApp(firebaseConfig);

new Vue({
  vuetify,
  router,
  firebase,
  render: (h) => h(App),
}).$mount("#app");
